import { createSlice } from "@reduxjs/toolkit";

type navbarType = {
  open: boolean;
};
const initialState: navbarType = {
  open: true,
};

const IsShowNavbar = createSlice({
  name: "open",
  initialState,
  reducers: {
    setShowNavbar: (state) => {
      return { ...state, open: true };
    },
    unsetShowNavbar: (state) => {
      return { ...state, open: false };
    },
    toggleNavbar: (state) => {
      state.open = !state.open;
    },
  },
});

export const { setShowNavbar, unsetShowNavbar, toggleNavbar } =
  IsShowNavbar.actions;
export default IsShowNavbar.reducer;
